import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {format} from 'ag-common/facades'
import StyledText from '#components/a/StyledText'
import NavVersetzungsplan from '#components/svg/icons/NavVersetzungsplan'
import {routeKeys} from '#config/routeKeys'

export default class VersetzungsplanAbteilungUpdateBenachrichtigung extends React.Component {
  onClickNotification = () => {
    const {onNotificationClick} = this.props
    onNotificationClick(routeKeys.ablaufundtermine)
  }

  render() {
    const {abteilungName, from} = this.props
    const text = i18n.t('notification_text_versetzungsplan_abteilung_update', [
      abteilungName,
      format(new Date(from), 'dd.MM.yy'),
    ])
    return (
      <div
        role="button"
        tabIndex={0}
        className="notification"
        onClick={this.onClickNotification}
        onKeyPress={this.onClickNotification}>
        <div className="notification__icon">
          <NavVersetzungsplan />
        </div>
        <StyledText text={text} modifier="notification" />
      </div>
    )
  }
}

VersetzungsplanAbteilungUpdateBenachrichtigung.propTypes = {
  abteilungName: PropTypes.string,
  from: PropTypes.string,
  onNotificationClick: PropTypes.func.isRequired,
}
